module.exports = __webpack_public_path__ + "img/about-list1-2.aca8b8e4.png";